import { render } from "./CardFooter.vue?vue&type=template&id=af9bbff0&scoped=true&ts=true"
import script from "./CardFooter.vue?vue&type=script&lang=ts"
export * from "./CardFooter.vue?vue&type=script&lang=ts"

import "./CardFooter.vue?vue&type=style&index=0&id=af9bbff0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9bbff0"]])

export default __exports__